import { Grid } from "@mui/material";
import React from "react";
import { Container } from "./styles";
import { AlertLineReportDTO } from "../../../models/alert-line-report/alert-line-report-dto";
import { AlertLineReportNoteDTO } from "../../../models/alert-line-report-note/alert-line-report-note-dto";
import AlertLinePageHeader from "../../../views/alert-line-report/AlertLinePage/AlertLinePageHeader";
import AlertLineReportNotes from "../../AlertLineReportNotes/AlertLineReportNotes";
import AlertLineReportDetails from "../AlertLineReportDetails";

interface Props {
  alertLineReport: AlertLineReportDTO;
  allNotes?: AlertLineReportNoteDTO[];
}

const ExportedAlertLineReport = ({ alertLineReport, allNotes }: Props) => {
  return (
    <Container>
      <AlertLinePageHeader
        alertLineURLId={alertLineReport.alertLineURL?.id}
        previousReport={alertLineReport}
      />
      <Grid style={{ padding: "10px" }}>
        <AlertLineReportDetails
          alertLineReport={alertLineReport}
          forExport
        />
        <br />
        <AlertLineReportNotes
          allNotes={allNotes}
          alertLineReport={alertLineReport}
          forExport
        />
      </Grid>
    </Container>
  );
};
export default ExportedAlertLineReport;
